export default __webpack_public_path__ + "static/media/visual_01.3e00dd25.png";